// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhs_a bih_h","Menu__offsetParent":"bhs_b bih_bj","Menu__trigger--shadowed":"bhs_c"};